//@ts-nocheck
import { Route, Routes } from "react-router-dom";

import SomethingWentWrong from "../pages/SomethingWentWrong";


// https://adarshaacharya.com.np/blog/role-based-auth-with-react-router-v6

/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = () => {
  return (
    <Routes>
      
        <Route path={"/something-went-wrong"} element={<SomethingWentWrong />} />
        
      
    </Routes>
  );
};

export default Router;